/* eslint-disable */
import React, { Component } from 'react'
import { Link } from 'react-router'
import Languages from './../../components/Languages'
import T from './../../translations/translate'
import Iframe from 'react-iframe';
import SkyLight from 'react-skylight';



/**
 * Create the nav bar 
 * 
 * Available props
 * items
 * path
 * title
 */



export default class NavBarUI extends Component {
    constructor(props){
        super(props);
       
        
        this.state = {
           
            type: this.props.type,
         
        }
    }


    componentWillReceiveProps(nextProps) {
        if(this.props.type !== nextProps){
            this.setState({ type: [nextProps.type] }); 
            
           // console.log("next props:",this.state.type);
        }
    }

   


    generateBreadCrumb(items, path, title) {
        console.log('items: ', items, "path: ", path, "props", this.props);
        if (items) {
            return (<div>
                {
                    items.map((item, index) => {
                        if (index === 0) {
                            path += item;
                        } else {
                            path += "+" + item;
                        }
                        return (
                            <Link className="navbar-brand" to={path}>{item === "rab_saas_site" ? T.ts(item) : item}
                                <span className="breadcrumbSeparator">{index === items.length - 1 ? "" : "/"}</span>
                                <div className="ripple-container"></div>
                            </Link>)
                    })}
            </div>)
        } else {
            return (<div></div>)
        }
    }

    render() {
        /* Added by Sneha */
        let previewUrl = '';
        let previewBtn;

        let myMobilePreview = {
            backgroundColor: '#ffffff',
            color: '#ffffff',
            width: '364px',
            height: '650px',
            marginTop: '-15%',
            marginLeft: '-11%',
        };

        if (this.props.items != undefined) {
            let itemArr = this.props.items;
            // console.log("items : ", itemArr, "path :", this.props.path,'contsins item',itemArr.includes("item"));
            // console.log("type: ", this.props.type)
            if(itemArr.includes("item") && this.props.type != undefined){
                previewUrl = `https://mycorpreview.harplabs.com/menu/tabs/${this.props.items}/${this.props.type}`;
                console.log('raw previewUrl',previewUrl)
                 previewUrl = previewUrl.replace(/,/g, '/');

            }else if(this.props.type != undefined){
                previewUrl = `https://mycorpreview.harplabs.com/menu/tabs/${this.props.items[0]}/${this.props.type}`;
            }else{
                previewUrl = `https://mycorpreview.harplabs.com/menu/tabs/${this.props.items[0]}`;
            }
            
           
            
            console.log('previewUrl',previewUrl)

            previewBtn = <div className="btn"
                style={{
                    padding: '10px',
                    display: 'block',
                    backgroundColor: '#7f8c8d',
                    margin: 'auto',
                    width: '150px',
                    color: '#ffffff',
                    fontSize: '2rem',
                    borderRadius: '5px'
                }}

                onClick={() => this.showPreview.show()}>Preview</div>

        }

        return (

            <div>


                <nav className="navbar navbar-transparent navbar-absolute fireadminbar">
                    <div className="container-fluid">
                        {
                            this.props.hideHamburger ?
                                <div></div> :
                                <div className="navbar-minimize">
                                    <button id="minimizeSidebar" className="minimizeSidebar btn btn-round btn-white btn-fill btn-just-icon">
                                        <i className="material-icons visible-on-sidebar-regular">more_vert</i>
                                        <i className="material-icons visible-on-sidebar-mini">view_list</i>
                                        <div className="ripple-container"></div></button>
                                </div>
                        }

                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle" data-toggle="collapse">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                            {this.generateBreadCrumb(this.props.items, this.props.path, this.props.altTitle)}
                        </div>

                        <div className="collapse navbar-collapse">
                            <ul className="nav navbar-nav navbar-right">
                                <li className="separator hidden-lg hidden-md" />
                                {
                                    this.props.hideHamburger ?
                                        <div></div> :
                                        <Languages
                                            countries={this.props.currentLangData.availableLaguages}
                                            defaultCountry={this.props.currentLangData.currentLang}
                                        />
                                }

                            </ul>
                        </div>

                        {/*  added by Sneha   */}
                        <SkyLight dialogStyles={myMobilePreview} hideOnOverlayClicked ref={ref => this.showPreview = ref} title="">
                            <Iframe url={previewUrl}
                                width="336px"
                                height="600px"
                                id="myId"
                                className="myClassname"
                                display="initial"
                                position="relative"
                                allowFullScreen />

                        </SkyLight>

                    </div>




                </nav>

                {previewBtn}

            </div>



        )
    }
}



// WEBPACK FOOTER //
// ./src/ui/template/NavBar.js